import { classNames } from '../../../utils';
import { CrossIcon } from '../../toast/assets';

type CloseButtonProps = {
  className?: string;
  disabled?: boolean;
  onClick: () => void;
  type?: 'submit' | 'reset' | 'button';
  size?: number;
};

export default function CloseButton({
  onClick,
  className,
  disabled,
  type = 'button',
  size = 12,
}: CloseButtonProps): JSX.Element {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        'focus:outline-none p-1.5 shadow-sm bg-white outline-none flex flex-row justify-center border border-gray-lightest rounded-md text-gray hover:text-green',
        className && className,
      )}
    >
      <CrossIcon
        width={size}
        height={size}
        strokeWidth={1.5}
        className='stroke-current'
      />
    </button>
  );
}
